import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class CounterText extends Phaser.GameObjects.Container {
  /**
     * 
     * @param {Phaser.Scene} scene 
     */
  constructor(scene, textTemplate, size, color) {
    super(scene);

    this.textTemplate = textTemplate;
    this.size = size;
    this.color = color;

    this.textLabel = ABCyaPhaser.Text.addText(0, 0, size, color, FontKeys._riffic_freebold, this.textTemplate.replace('_VALUE_', `${this.value}`), this).setOrigin(0);
  }

  setValue(value) {
    this.value = value;
    const result = this.textTemplate.replace('_VALUE_', `${value}`);
    this.textLabel.text = result;
  }

  addValue(value) {
    const newValue = this.value + value;
    this.setValue(newValue);
  }

  getValue() {
    return this.value;
  }
}